import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { NavigationProvider } from './app/navigation';
import { ThemeProvider } from './app/theme';
import { ApiError, NetworkError } from './api/http';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // A missing session or a rejected request will not fix itself; only
        // transient network failures are worth retrying.
        if (error instanceof ApiError) return false;
        if (error instanceof NetworkError) return failureCount < 2;
        return failureCount < 1;
      },
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <NavigationProvider>
          <App />
        </NavigationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
